import CASL from '@/utils/constants/casl'

export default {
  path: 'ditangguhkan',
  children: [
    {
      path: '',
      name: 'ditangguhkan.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.PENAWARAN_SO
      },
      component: () => import('./list/DitangguhkanListPage.vue')
    }
  ]
}
